import React from "react";

import SignIn from "../Components/Form/signIn";

function Signin() {
  return (
    <div>
      <SignIn />
    </div>
  );
}

export default Signin;
